import { __exports as get_internal_slots } from "../../../../_virtual/get_internal_slots.mjs";
var hasRequiredGet_internal_slots;
function requireGet_internal_slots() {
  if (hasRequiredGet_internal_slots) return get_internal_slots;
  hasRequiredGet_internal_slots = 1;
  Object.defineProperty(get_internal_slots, "__esModule", { value: true });
  get_internal_slots.getInternalSlots = void 0;
  var internalSlotMap = /* @__PURE__ */ new WeakMap();
  function getInternalSlots(x) {
    var internalSlots = internalSlotMap.get(x);
    if (!internalSlots) {
      internalSlots = /* @__PURE__ */ Object.create(null);
      internalSlotMap.set(x, internalSlots);
    }
    return internalSlots;
  }
  get_internal_slots.getInternalSlots = getInternalSlots;
  return get_internal_slots;
}
export {
  requireGet_internal_slots as __require
};
